import React from 'react';

class ProjectDescription extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
            text: this.props.text,
        };
    }

    render() {
      if(this.props.boxLink) {
        return (
          <a href={this.state.boxLink}>
            <div className="projectBox">
              <p>{this.state.text}</p>
            </div>
          </a>
          
        );
      }
      else{ 
        return (
            <div className="projectBox">
              <h2>{this.props.title}</h2>
              <p>{this.props.description}</p>
            </div>
        );
      }
    }
  }

export { ProjectDescription }; 